import type { KataTheme } from '../../data/catalog/types'

/** Multi-stop aurora gradient for kata practice / editor banners. */
export function kataBannerBackground(theme: KataTheme): string {
  const mid = `color-mix(in srgb, ${theme.from} 42%, ${theme.to})`
  return `linear-gradient(125deg, ${theme.from} 0%, ${mid} 48%, ${theme.to} 100%)`
}
